import { usePostOfficeBottomSheetState } from '@apps/admin/postOffice/PostOffice.bottomSheet';
import { useTranslation } from '@shared/core';
import { useEffect } from 'react';

interface ControllerProps {
  onVisible?: () => void;
}

export const useDesignEmailViewController = (props: ControllerProps) => {
  const { t } = useTranslation('postOffice');
  const tBottomSheet = t('bottomSheet');
  const tDesignEmail = tBottomSheet.designEmail;
  const { parentViewState } = usePostOfficeBottomSheetState();
  const handleButtonClick = parentViewState.openEmailEditor;
  const disableEditEmail = parentViewState.disableEditEmail;

  useEffect(() => {
    props.onVisible?.();
  }, [props, props.onVisible]);

  return { tDesignEmail, handleButtonClick, disableEditEmail };
};
